import React, {Component} from 'react';
import * as d3 from 'd3';
import _ from 'lodash';

import './HoverOver.css';

class HoverOver extends Component {

  defaultState = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    content: '',
    visible: false,
    direction: 'down'
  };

  /**
   * Constructor override
   *
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = this.defaultState;
  }

  /**
   * Called before update, allows us to convert props.data into state
   *
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    const margin = {
      top:nextProps.top || nextProps.margin || this.state.top || 0,
      bottom:nextProps.bottom || nextProps.margin || this.state.bottom || 0,
      left:nextProps.left || nextProps.margin || this.state.left || 0,
      right:nextProps.right || nextProps.margin || this.state.right || 0,
    };

    // Use data.coords to create hover contents
    if (nextProps.data && nextProps.data.coords) {
      const {coords, props, data} = nextProps.data;
      const hover = this.createHoverFromCoordinates(coords, props, data);

      this.setState({
        ...margin,
        ...hover
      });
    }
    // Use data.event to create hover contents
    else if (nextProps.data && nextProps.data.event) {
      const {event, props, data} = nextProps.data;
      const hover = this.createHoverFromEvent(event, props, data);

      this.setState({
        ...margin,
        ...hover
      });
    }
    // Assume formed hover with x,y,content
    else if (nextProps.data) {
      const {x, y, content} = nextProps.data;
      const direction = this.getDirection(x, y);
      const visible = content && (x > 0 || y > 0);
      this.setState({x, y, content, direction, visible, margin});
    }
    // If no data, hide hover
    else {
      this.setState({visible: false})
    }
  }

  /**
   * Get best hover direction based on x,y coordinates
   *
   * @param x
   * @param y
   * @returns {*}
   */
  getDirection(x, y) {
    const bounds = d3.select(this.refs.wrapper).node().getBoundingClientRect();
    const globalWidth = window.innerWidth;
    const globalX = x + bounds.left;
    const globalY = y + bounds.top;
    const xMargin = Math.max(globalWidth * .1, 100);
    const yMargin = 160;

    const navOffset = globalWidth > 640 ? 240 : 0;

    if (globalX < (xMargin + navOffset)) {
      return 'left';
    }
    else if (globalX > globalWidth - xMargin) {
      return 'right';
    }
    else if (globalY < yMargin) {
      return 'up';
    }
    else {
      return 'down';
    }
  }

  /**
   * Create a hover from mouse event, props, and data
   *
   * @param event
   * @param props
   * @param data
   * @returns {{x: *, y: *, content: *, direction: *, visible: *}}
   */
  createHoverFromEvent(event, props, data) {
    const x = event.clientX;
    const y = event.clientY;
    const direction = this.getDirection(x, y);
    const content = this.createHoverContent(props, data);
    const visible = content && (x > 0 || y > 0);

    return {x, y, content, direction, visible};
  }

  /**
   * Create a hover from coordinates array, props, and data
   *
   * @param coords
   * @param props
   * @param data
   * @returns {{x, y, content: *, direction: *, visible: (*|boolean)}}
   */
  createHoverFromCoordinates(coords, props, data) {
    const x = _.get(coords, 0, 0);
    const y = _.get(coords, 1, 0);
    const direction = this.getDirection(x, y);
    const content = this.createHoverContent(props, data);
    const visible = content && (x > 0 || y > 0);

    return {x, y, content, direction, visible};
  }

  /**
   * Using props and data (from the common opioid charts)
   * create textual content based off the county/state name,
   * group, or x/y fields
   *
   * @param props
   * @param data
   * @returns {*}
   */
  createHoverContent(props, data) {
    if (!data) {
      return null;
    }

    // Create best name from project specific data sources
    let name = '';

    if (data.group) {
      name = data.group;
    }
    else if (data.cn && data.cn !== 'STATE TOTAL' && data.cn !== 'NATIONAL TOTAL') {
      name = data.cn + ", " + data.sa;
    }
    else {
      name = data.sn;
    }

    if (props.year){
      name += ' - ' + props.year;
    }
    else if (data.year){
      name += ' - ' + data.year;
    }

    const index = 2015 - (props.year || 2015);

    // x value labels
    const xContent = (
      <div><b className="red">{props.titleX || 'Red Dimension'} : </b>
        <i>{d3.format(',')(_.get(data, [props.dimX, index], 'No X Data'))}</i>
      </div>
    );

    // y value labels
    const yContent = (
      <div><b className="blue">{props.titleY || 'Blue Dimension'} : </b>
        <i>{d3.format(',')(_.get(data, [props.dimY, index], 'No Y Data'))}</i>
      </div>
    );

    return (
      <div>
        <h4>{name}</h4>
        {props.dimX || props.dimY || data.content ? <div className="spacer"/> : ''}
        {props.dimX ? xContent : ''}
        {props.dimY ? yContent : ''}
        {data.content ? data.content : ''}
      </div>
    );
  }

  render() {
    return (
      <div ref="wrapper" className="HoverOver wrapper" style={{
        overflow: 'visible !important',
        top: this.state.top || 0,
        bottom: this.state.bottom || 0,
        left: this.state.left || 0,
        right: this.state.right || 0
      }}>
        <div className="position" style={{
          width: 0,
          height: 0,
          overflow: 'visible !important',
          position: 'relative',
          left: this.state.x + "px",
          top: this.state.y + "px",
          display: this.state.visible ? 'block' : 'none'
        }}>
          <div className={"d3tooltip arrow-tooltip-" + this.state.direction}>{this.state.content}</div>
        </div>
      </div>
    );
  }
}

export default HoverOver;


// WEBPACK FOOTER //
// ./src/charts/HoverOver/index.js